var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFullYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67399",
    "data-name": "Group 67399",
    transform: "translate(0.244 0.245)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22931",
    "data-name": "Rectangle 22931",
    width: 24,
    height: 24,
    rx: 7,
    transform: "translate(-0.245 -0.245)",
    fill: "#e73323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M7.718,10.847a46.313,46.313,0,0,1-6.034-.323A1.964,1.964,0,0,1,.323,9.178,20.4,20.4,0,0,1,0,5.438,20.377,20.377,0,0,1,.323,1.726,1.954,1.954,0,0,1,1.684.323,46.313,46.313,0,0,1,7.718,0a50.737,50.737,0,0,1,6.034.295,1.956,1.956,0,0,1,1.361,1.4,20.334,20.334,0,0,1,.323,3.74,20.444,20.444,0,0,1-.323,3.684,1.956,1.956,0,0,1-1.361,1.4A46.313,46.313,0,0,1,7.718,10.847ZM6.312,3.129V7.718l4.035-2.294Z",
    transform: "translate(3.908 6.332)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullYoutube);
export default __webpack_public_path__ + "static/media/icon-full-youtube.ebf391fc1f74e4330260370893ab9224.svg";
export { ForwardRef as ReactComponent };